export default {
  ru: {
    dataIterator: {
      rowsPerPageText: 'Кол-во записей на страницу:',
      rowsPerPageAll: 'Все',
      pageText: 'Строки {0}-{1} из {2}',
      noResultsText: 'Нет данных для отображения',
      nextPage: 'Следующая страница',
      prevPage: 'Предыдущая страница'
    },
    dataTable: {
      rowsPerPageText: 'Кол-во строк:'
    },
    noDataText: 'Нет данных для отображения'
  }
}
